import { authQueryKeys as e } from "./useAuthQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { authApi as n } from "@maat/api-main";
//#region src/queries/state/useMeQuery.ts
var r = (r = !1) => t({
	queryKey: e.me(),
	queryFn: n.me,
	retry: !1,
	enabled: r
});
//#endregion
export { r as useMeQuery };
